import { render, staticRenderFns } from "./myBuffeloviewdetails.vue?vue&type=template&id=3cc12c80&"
import script from "./myBuffeloviewdetails.vue?vue&type=script&lang=js&"
export * from "./myBuffeloviewdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports